import type { ReactNode } from "react";
import { Component } from "react";
import { t } from "@/i18n-js/instance";
import { useBuilderStoreErrorMessage } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";

interface BuilderUIErrorProps {
  children: ReactNode;
}

interface BuilderUIErrorState {
  hasError: boolean;
}

export class BuilderUIErrorBoundary extends Component<
  BuilderUIErrorProps,
  BuilderUIErrorState
> {
  static getDerivedStateFromError(error: unknown) {
    if (
      error instanceof Error &&
      error.message.includes(useBuilderStoreErrorMessage)
    ) {
      return { hasError: true };
    }

    throw error;
  }

  override state: BuilderUIErrorState = {
    hasError: false,
  };

  override render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div
          role="alert"
          className="bg-primary text-dark p-30 fixed inset-0 z-50 flex items-center justify-center text-2xl font-bold"
        >
          {t("builder_ui.errors.use_builder_store_error")}
        </div>
      );
    }

    return children;
  }
}
